import { BindCardOptionsV2 } from '../types';
import { createVerificationIntent } from '../utils/createVerificationIntent';

export const createBindingApi2 = async (apiHost: string, params: BindCardOptionsV2) => {
    return createVerificationIntent(apiHost, {
        ...params,
        flow: 'card',
    });
};
